export function areasdata() {
	var CityGroupList = [{
		"id": 1,
		"name": "长三角地区",
		"isDefault": 1,
		"children": [{
			"areaId": 31,
			"areaName": "上海市"
		}, {
			"areaId": 3201,
			"areaName": "南京市"
		}, {
			"areaId": 3202,
			"areaName": "无锡市"
		}, {
			"areaId": 3204,
			"areaName": "常州市"
		}, {
			"areaId": 3205,
			"areaName": "苏州市"
		}, {
			"areaId": 3206,
			"areaName": "南通市"
		}, {
			"areaId": 3209,
			"areaName": "盐城市"
		}, {
			"areaId": 3210,
			"areaName": "扬州市"
		}, {
			"areaId": 3211,
			"areaName": "镇江市"
		}, {
			"areaId": 3212,
			"areaName": "泰州市"
		}, {
			"areaId": 3301,
			"areaName": "杭州市"
		}, {
			"areaId": 3302,
			"areaName": "宁波市"
		}, {
			"areaId": 3304,
			"areaName": "嘉兴市"
		}, {
			"areaId": 3305,
			"areaName": "湖州市"
		}, {
			"areaId": 3306,
			"areaName": "绍兴市"
		}, {
			"areaId": 3307,
			"areaName": "金华市"
		}, {
			"areaId": 3309,
			"areaName": "舟山市"
		}, {
			"areaId": 3310,
			"areaName": "台州市"
		}, {
			"areaId": 3401,
			"areaName": "合肥市"
		}, {
			"areaId": 3402,
			"areaName": "芜湖市"
		}, {
			"areaId": 3405,
			"areaName": "马鞍山市"
		}, {
			"areaId": 3407,
			"areaName": "铜陵市"
		}, {
			"areaId": 3408,
			"areaName": "安庆市"
		}, {
			"areaId": 3411,
			"areaName": "滁州市"
		}, {
			"areaId": 3417,
			"areaName": "池州市"
		}, {
			"areaId": 3418,
			"areaName": "宣城市"
		}]
	}, {
		"id": 2,
		"name": "珠三角地区",
		"isDefault": 0,
		"children": [{
			"areaId": 4401,
			"areaName": "广州市"
		}, {
			"areaId": 4402,
			"areaName": "韶关市"
		}, {
			"areaId": 4403,
			"areaName": "深圳市"
		}, {
			"areaId": 4404,
			"areaName": "珠海市"
		}, {
			"areaId": 4405,
			"areaName": "汕头市"
		}, {
			"areaId": 4406,
			"areaName": "佛山市"
		}, {
			"areaId": 4407,
			"areaName": "江门市"
		}, {
			"areaId": 4408,
			"areaName": "湛江市"
		}, {
			"areaId": 4409,
			"areaName": "茂名市"
		}, {
			"areaId": 4412,
			"areaName": "肇庆市"
		}, {
			"areaId": 4413,
			"areaName": "惠州市"
		}, {
			"areaId": 4414,
			"areaName": "梅州市"
		}, {
			"areaId": 4415,
			"areaName": "汕尾市"
		}, {
			"areaId": 4416,
			"areaName": "河源市"
		}, {
			"areaId": 4417,
			"areaName": "阳江市"
		}, {
			"areaId": 4418,
			"areaName": "清远市"
		}, {
			"areaId": 4419,
			"areaName": "东莞市"
		}, {
			"areaId": 4420,
			"areaName": "中山市"
		}, {
			"areaId": 4451,
			"areaName": "潮州市"
		}, {
			"areaId": 4452,
			"areaName": "揭阳市"
		}, {
			"areaId": 4453,
			"areaName": "云浮市"
		}]
	}, {
		"id": 3,
		"name": "京津冀地区",
		"isDefault": 0,
		"children": [{
			"areaId": 11,
			"areaName": "北京市"
		}, {
			"areaId": 12,
			"areaName": "天津市"
		}, {
			"areaId": 1301,
			"areaName": "石家庄市"
		}, {
			"areaId": 1302,
			"areaName": "唐山市"
		}, {
			"areaId": 1303,
			"areaName": "秦皇岛市"
		}, {
			"areaId": 1304,
			"areaName": "邯郸市"
		}, {
			"areaId": 1305,
			"areaName": "邢台市"
		}, {
			"areaId": 1306,
			"areaName": "保定市"
		}, {
			"areaId": 1307,
			"areaName": "张家口市"
		}, {
			"areaId": 1308,
			"areaName": "承德市"
		}, {
			"areaId": 1309,
			"areaName": "沧州市"
		}, {
			"areaId": 1310,
			"areaName": "廊坊市"
		}, {
			"areaId": 1311,
			"areaName": "衡水市"
		}, {
			"areaId": 4105,
			"areaName": "安阳市"
		}]
	}, {
		"id": 4,
		"name": "成渝地区",
		"isDefault": 0,
		"children": [{
			"areaId": 50,
			"areaName": "重庆市"
		}, {
			"areaId": 5101,
			"areaName": "成都市"
		}, {
			"areaId": 5106,
			"areaName": "德阳市"
		}, {
			"areaId": 5107,
			"areaName": "绵阳市"
		}, {
			"areaId": 5111,
			"areaName": "乐山市"
		}]
	}, {
		"id": 5,
		"name": "闽东南地区",
		"isDefault": 0,
		"children": [{
			"areaId": 3501,
			"areaName": "福州市"
		}, {
			"areaId": 3502,
			"areaName": "厦门市"
		}, {
			"areaId": 3503,
			"areaName": "莆田市"
		}, {
			"areaId": 3505,
			"areaName": "泉州市"
		}, {
			"areaId": 3506,
			"areaName": "漳州市"
		}, {
			"areaId": 3507,
			"areaName": "南平市"
		}, {
			"areaId": 3509,
			"areaName": "宁德市"
		}]
	}]
	return CityGroupList; 
}
